import * as React from 'react';
import * as TabsPrimitive from '@radix-ui/react-tabs';
import { cn } from '../../lib/utils.js';

const Tabs = TabsPrimitive.Root;

const TabsList = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    className={cn(
      'inline-flex h-10 items-center justify-center rounded-[var(--radius-element,var(--radius))] bg-[var(--surface-container-low)] p-1 text-[var(--color-text-secondary,var(--secondary))]',
      className,
    )}
    ref={ref}
    data-astryx-tablist=""
    {...props}
  />
));
TabsList.displayName = 'TabsList';

const TabsTrigger = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Trigger
    className={cn(
      'inline-flex items-center justify-center whitespace-nowrap rounded-[var(--radius-sm)] px-3 py-1.5 text-sm font-semibold transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring,var(--color-accent))] disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-white data-[state=active]:text-[var(--color-text-primary,var(--foreground))] data-[state=active]:shadow-sm cursor-pointer',
      className,
    )}
    ref={ref}
    data-astryx-tab=""
    {...props}
  />
));
TabsTrigger.displayName = 'TabsTrigger';

const TabsContent = React.forwardRef(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    className={cn('mt-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring,var(--color-accent))]', className)}
    ref={ref}
    {...props}
  />
));
TabsContent.displayName = 'TabsContent';

export { Tabs, TabsList, TabsTrigger, TabsContent };
